export default "__VITE_ASSET__CU5dz7c2__"